import {
  PRODUCT_TRANSACTION_LOG_ALL,
  PRODUCT_TRANSACTION_LOG_GET,
  PRODUCT_TRANSACTION_LOG_ERROR,
  PRODUCT_TRANSACTION_LOG_RESET,
} from '../types';

import api from '../../../utils/functions/api';

export const productTransactionLogAll = (params) => async (dispatch) => {
  try {
    const {
      name = '',
      size = '',
      page = 1,
      transactionType = '',
      startDate = '',
      endDate = '',
      DashBoardDaily = '',
      DashBoardPage = false,
      selectDate = '',
    } = params;
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/product-transaction-log?name=${name}&size=${size}&page=${page}&type=${transactionType}&startDate=${startDate}&endDate=${endDate}&DashBoardDaily=${DashBoardDaily}&DashBoardPage=${DashBoardPage}&selectDate=${selectDate}`,
    );
    if (status === 200) {
      dispatch({ type: PRODUCT_TRANSACTION_LOG_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: PRODUCT_TRANSACTION_LOG_ERROR });
    throw new Error(error);
  }
};

export const productTransactionLogReset = () => async (dispatch) => {
  try {
    const data = [];
    dispatch({ type: PRODUCT_TRANSACTION_LOG_RESET, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: PRODUCT_TRANSACTION_LOG_ERROR });
    throw new Error(error);
  }
};

export const productTransactionLogGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/product-transaction-log/${id}`,
    );
    if (status === 200) {
      dispatch({ type: PRODUCT_TRANSACTION_LOG_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: PRODUCT_TRANSACTION_LOG_ERROR });
    throw new Error(error);
  }
};
